import React, { Component } from 'react';
import moment from 'moment';
import { compose } from '../../../../reactApolloCompat';
import cloneDeep from 'lodash.clonedeep';
import withStyles from '@mui/styles/withStyles';
import TabbedModal from '../../../../component/form/TabbedModal';
import BillingDetailsTab, { convertToCustomer } from './BillingDetailsTab';
import InvoiceDetailsTab from './InvoiceDetailsTab';
import PaymentHistoryTab from './PaymentHistoryTab';
import { withSnackbarMessage } from '../../../../context/SnackbarMessage';
import {
    authoriseToXeroFunc,
    createInvoiceFunc,
    sendInvoiceXeroFunc,
    submitToXeroFunc,
    updateInvoiceFunc
} from './GetSaveInvoice';
import InvoicePDFTab from './InvoicePDFTab';
import { isRelatedObjectUndefined } from '../../../../util/graphql';
import { createForm } from '../../../../util/form';
import { GST, ProductConfig, QueryKeys } from '../../../../util/products';
import { isCategory } from '../../../mortuary/Coffin/CoffinListConstants';
import { isNullOrUndefined } from '../../../../util/objects';
import { PO_DOCTOR_LIST, PO_SUPPLIER_LIST } from '../../funeralConstants';
import { WhiteLoader } from '../../../../component/WhiteLoader';

const EDITABLE_TABS = [{ label: 'Billing' }, { label: 'Line Items' }, { label: 'Preview Invoice' }];
const READONLY_TABS = [{ label: 'View Invoice' }, { label: 'Payments' }];
const EXPORTED_XERO_TABS = [{ label: 'View Invoice' }, { label: 'View PDF' }, { label: 'Payments' }];

class InvoiceModal extends Component {
    state = {
        tabIndex: 0,
        invoiceIndex: null,
        loading: false,
        form: null
    };

    static getDerivedStateFromProps({ open, invoiceIndex, defaultBillTo, form }, state) {
        const invoice = form.getField(`Invoices[${invoiceIndex}]`);
        const legacyKey = invoice && invoice.LegacyKey;
        const xeroID = invoice && invoice.XeroID;
        const newState = { open };

        if (state.open !== open && open) {
            newState.tabIndex = 0;
            newState.cart = [];

            if (!isNullOrUndefined(invoice)) {
                let clonedInvoice = cloneDeep(invoice);
                if (isRelatedObjectUndefined(clonedInvoice)) clonedInvoice.Customer = convertToCustomer(defaultBillTo);
                //customer needs a 'billing source'.
                if (!clonedInvoice.Customer.BillingSource)
                    clonedInvoice.Customer.BillingSource = !!clonedInvoice.Customer.RelationToDeceased
                        ? 'FamilyMember'
                        : 'Other';
                const oldContext = state.form !== null ? state.form.context : null;
                newState.form = createForm(oldContext, clonedInvoice);
                newState.invoiceIndex = invoiceIndex;
            } else {
                newState.form = createForm(null, { FuneralID: form.getField('ID') });
                newState.invoiceIndex = null;
            }

            newState.defaultBillTo = defaultBillTo;
            newState.canEdit = !legacyKey && !xeroID;
            newState.hasExportedToXero = !!xeroID;
            newState.existing = invoiceIndex !== null;
        }
        return newState;
    }

    componentDidUpdate(_, oldState) {
        const { loading, open, invoiceIndex, form } = this.state;
        if (open && invoiceIndex === null && !loading) {
            //no invoice! create one
            this.createInvoice();
            return;
        }

        if (oldState.form === null && form !== null) form.context = this;
    }

    render() {
        const { classes, onClose, quotes, isPurchase, form: parentForm } = this.props;
        const {
            tabIndex,
            loading,
            invoiceIndex,
            defaultBillTo,
            canEdit,
            existing,
            hasExportedToXero,
            form
        } = this.state;
        const invoice = parentForm.getField(`Invoices[${invoiceIndex}]`);
        const isBill = !!invoice ? invoice.IsPurchase : !!isPurchase;
        const label = isBill ? 'Bill' : 'Invoice';

        if (isNullOrUndefined(form)) return null;

        let tab;
        let tab_names;

        if (canEdit && !hasExportedToXero) {
            tab_names = EDITABLE_TABS.map(obj => obj.label.replace(/Invoice/, label));

            if (tabIndex === 0) {
                tab = (
                    <BillingDetailsTab
                        stepNumber="One"
                        onSubmit={() => this.onSubmit()}
                        nextTab={this.nextTab}
                        loading={loading}
                        onCancel={onClose}
                        invoiceIndex={invoiceIndex}
                        defaultBillTo={defaultBillTo}
                        canEdit={canEdit}
                        existing={existing}
                        form={form}
                        parentForm={parentForm}
                    />
                );
            } else if (tabIndex === 1) {
                const quotedLineItems = convertQuotedAsLineItems(quotes, isBill); // quotes
                const billedLineItems = convertBilledAsLineItems(parentForm, isBill); // bills (purchase orders)
                const bookedLineItems = convertBookedAsLineItems(parentForm, isBill); // bookings
                tab = (
                    <InvoiceDetailsTab
                        stepNumber="Two"
                        form={form}
                        onSubmit={() => this.onSubmit()}
                        // onSubmitToXero={() => this.onSubmitToXero()}
                        previousTab={this.previousTab}
                        nextTab={this.nextTab}
                        loading={loading}
                        onCancel={onClose}
                        invoice={form.state}
                        invoiceIndex={invoiceIndex}
                        defaultBillTo={defaultBillTo}
                        prefill={{ quotedLineItems, billedLineItems, bookedLineItems }}
                        canEdit={canEdit}
                        canSubmit={false}
                        existing={existing}
                        hasExportedToXero={hasExportedToXero}
                    />
                );
            } else if (tabIndex === 2) {
                tab = (
                    <InvoiceDetailsTab
                        stepNumber="Three"
                        form={form}
                        onSubmit={() => this.onSubmit()}
                        onSubmitToXero={() => this.onSubmitToXero()}
                        previousTab={this.previousTab}
                        nextTab={this.nextTab}
                        loading={loading}
                        onCancel={onClose}
                        invoice={form.state}
                        invoiceIndex={invoiceIndex}
                        defaultBillTo={defaultBillTo}
                        canEdit={false}
                        canSubmit={true}
                        existing={existing}
                        hasExportedToXero={hasExportedToXero}
                    />
                );
            }
        } else if (!canEdit && hasExportedToXero) {
            tab_names = EXPORTED_XERO_TABS.map(obj => obj.label.replace(/Invoice/, label));

            if (tabIndex === 0) {
                tab = (
                    <InvoiceDetailsTab
                        form={form}
                        onSubmit={() => this.onSubmit()}
                        nextTab={this.nextTab}
                        loading={loading}
                        onCancel={onClose}
                        invoice={form.state}
                        invoiceIndex={invoiceIndex}
                        defaultBillTo={defaultBillTo}
                        canEdit={canEdit}
                        existing={existing}
                        hasExportedToXero={hasExportedToXero}
                        onAuthoriseToXero={() => this.onAuthoriseToXero()}
                        onEdit={this.onEdit}
                    />
                );
            } else if (tabIndex === 1) {
                tab = (
                    <InvoicePDFTab
                        form={form}
                        onSubmit={() => this.onSubmit()}
                        nextTab={this.nextTab}
                        previousTab={this.previousTab}
                        loading={loading}
                        onCancel={onClose}
                        invoice={form.state}
                        invoiceIndex={invoiceIndex}
                        purchaseOrders={getPurchaseOrderList(parentForm)}
                        canEdit={canEdit}
                        existing={existing}
                        onSendEmail={this.sendInvoiceXero} // authorise also sends
                    />
                );
            } else if (tabIndex === 2) {
                tab = (
                    <PaymentHistoryTab
                        form={form}
                        onSubmit={() => this.onSubmit()}
                        nextTab={this.nextTab}
                        previousTab={this.previousTab}
                        loading={loading}
                        onCancel={onClose}
                        invoice={form.state}
                        invoiceIndex={invoiceIndex}
                        defaultBillTo={defaultBillTo}
                        canEdit={canEdit}
                        existing={existing}
                    />
                );
            }
        } else {
            tab_names = READONLY_TABS.map(obj => obj.label.replace(/Invoice/, label));

            if (tabIndex === 0) {
                tab = (
                    <InvoiceDetailsTab
                        form={form}
                        onSubmit={() => this.onSubmit()}
                        nextTab={this.nextTab}
                        loading={loading}
                        onCancel={onClose}
                        invoice={form.state}
                        invoiceIndex={invoiceIndex}
                        defaultBillTo={defaultBillTo}
                        canEdit={canEdit}
                        existing={existing}
                        hasExportedToXero={hasExportedToXero}
                    />
                );
            } else if (tabIndex === 1) {
                tab = (
                    <PaymentHistoryTab
                        form={form}
                        onSubmit={() => this.onSubmit()}
                        nextTab={this.nextTab}
                        previousTab={this.previousTab}
                        loading={loading}
                        onCancel={onClose}
                        invoice={form.state}
                        invoiceIndex={invoiceIndex}
                        defaultBillTo={defaultBillTo}
                        canEdit={canEdit}
                        existing={existing}
                    />
                );
            }
        }

        return (
            <TabbedModal
                className={classes.modalMagick}
                tabs={tab_names}
                tabIndex={tabIndex}
                onChange={this.onChangeTab}
                {...this.props}
            >
                {tab}
                {!!loading && <WhiteLoader />}
            </TabbedModal>
        );
    }

    onChangeTab = tabIndex => {
        this.setState({ tabIndex });
    };

    nextTab = () => {
        this.setState({ tabIndex: this.state.tabIndex + 1 });
    };

    previousTab = () => {
        this.setState({ tabIndex: this.state.tabIndex - 1 });
    };

    onEdit = () => {
        this.setState({
            hasExportedToXero: false,
            canEdit: true,
            tabIndex: 1
        });
    };

    onSubmit() {
        this.updateInvoice();
    }

    onSubmitToXero() {
        const me = this;
        this.submitToXero().then(() => {
            me.setState({ tabIndex: 1 });
        });
    }

    onAuthoriseToXero() {
        const me = this;
        this.authoriseToXero().then(() => {
            me.setState({ tabIndex: 1 });
        });
    }

    createInvoice() {
        const { defaultBillTo, isPurchase } = this.props;
        const parentForm = this.props.form;
        if (parentForm.loading !== false) return;

        this.setState({ loading: true });
        const that = this;

        const dos = moment(parentForm.getField('DateOfService'));
        const due = (!!dos && dos.isValid() && dos) || moment();

        //add form details
        const form = createForm(that, {
            Funeral: { ID: parentForm.getField('ID') },
            InvoiceItems: [],
            SalesRegisterTransactions: [],
            InvoiceDate: moment().format('YYYY-MM-DD'),
            InvoiceDueDate: due.add(21, 'days').format('YYYY-MM-DD'),
            IsPurchase: isPurchase,
            Customer: convertToCustomer(defaultBillTo)
        });

        const Invoices = parentForm.getField('Invoices') || [];
        const invoiceIndex = Invoices.length;
        that.setState({ loading: false, invoiceIndex, form });
        return null;
    }

    updateInvoice() {
        const { invoiceIndex } = this.state;
        let invoice = this.state.form.state;
        const parentForm = this.props.form;

        this.setState({ loading: true });
        const that = this;
        const original = parentForm.getField(`Invoices[${invoiceIndex}]`);

        if (!invoice.ID || invoice.ID === '0')
            return createInvoiceFunc(invoice).then(
                ({ data }) => {
                    const Invoices = parentForm.getField('Invoices') || [];
                    const createdInvoice = cloneDeep(data.createInvoice);
                    Invoices.push(createdInvoice);
                    parentForm.setField({ Invoices }, false);

                    const invoiceIndex = Invoices.length - 1;
                    that.setState({ loading: false, invoiceIndex, form: createForm(that, createdInvoice) });
                    this.props.setSnackbarMessage('Success, your invoice was created.', true);
                },
                e => that.onGqlError('Failed to create invoice.', e)
            );

        if (!invoice.XeroID) {
            return updateInvoiceFunc(invoice, original).then(
                ({ data }) => {
                    const Invoices = parentForm.getField('Invoices') || [];
                    const updatedInvoice = cloneDeep(data.updateInvoice);
                    Object.assign({}, Invoices[invoiceIndex], updatedInvoice);
                    parentForm.setField({ Invoices }, false);
                    that.setState({ loading: false, form: createForm(that, updatedInvoice) });
                    this.props.setSnackbarMessage('Success, your invoice was updated.', true);
                },
                e => that.onGqlError('Failed to update invoice.', e)
            );
        } else {
            // update case after exported to xero
            return updateInvoiceFunc(invoice, original).then(
                () => {
                    return submitToXeroFunc(invoice).then(
                        ({ data }) => {
                            const Invoices = parentForm.getField('Invoices') || [];
                            const updatedInvoice = cloneDeep(data.submitInvoiceToXero);
                            Object.assign(Invoices[invoiceIndex], updatedInvoice);
                            parentForm.setField({ Invoices }, false);
                            that.setState({
                                loading: false,
                                invoice: updatedInvoice,
                                hasExportedToXero: true,
                                canEdit: false
                            });
                            this.props.setSnackbarMessage('Success, your invoice was updated.', true);
                        },
                        e => that.onGqlError('Failed to submit invoice to xero.', e)
                    );
                },
                e => that.onGqlError('Failed to update invoice.', e)
            );
        }
    }

    authoriseToXero = () => {
        const parentForm = this.props.form;
        const { invoiceIndex, form } = this.state;

        this.setState({ loading: true });
        const that = this;

        return authoriseToXeroFunc(form.state).then(
            ({ data }) => {
                const Invoices = parentForm.getField('Invoices') || [];
                const updatedInvoice = cloneDeep(data.authoriseInvoiceToXero);
                Object.assign(Invoices[invoiceIndex], updatedInvoice);
                parentForm.setField({ Invoices }, false);
                that.setState({
                    loading: false,
                    form: createForm(that, cloneDeep(updatedInvoice)),
                    hasExportedToXero: true,
                    canEdit: false
                });
                this.props.setSnackbarMessage('Success, your invoice was updated.', true);
            },
            e => that.onGqlError('Failed to authorise invoice.', e)
        );
    };

    sendInvoiceXero = () => {
        const parentForm = this.props.form;
        const { invoiceIndex, form } = this.state;

        this.setState({ loading: true });
        const that = this;

        return sendInvoiceXeroFunc(form.state).then(
            ({ data }) => {
                const Invoices = parentForm.getField('Invoices') || [];
                const updatedInvoice = cloneDeep(data.sendInvoiceXero);
                Object.assign(Invoices[invoiceIndex], updatedInvoice);
                parentForm.setField({ Invoices }, false);
                that.setState({
                    loading: false,
                    form: createForm(that, cloneDeep(updatedInvoice)),
                    hasExportedToXero: true,
                    canEdit: false
                });
                this.props.setSnackbarMessage('Success, your invoice was sent.', true);
            },
            e => that.onGqlError('Failed to send invoice.', e)
        );
    };

    submitToXero = () => {
        const parentForm = this.props.form;
        const { invoiceIndex, form } = this.state;

        this.setState({ loading: true });
        const that = this;
        const original = parentForm.getField(`Invoices[${invoiceIndex}]`);

        return updateInvoiceFunc(form.state, original).then(
            () => {
                return submitToXeroFunc(form.state).then(
                    ({ data }) => {
                        const Invoices = parentForm.getField('Invoices') || [];
                        const updatedInvoice = cloneDeep(data.submitInvoiceToXero);
                        Object.assign(Invoices[invoiceIndex], updatedInvoice);
                        parentForm.setField({ Invoices }, false);
                        that.setState({
                            loading: false,
                            form: createForm(that, cloneDeep(updatedInvoice)),
                            hasExportedToXero: true,
                            canEdit: false
                        });
                        this.props.setSnackbarMessage('Success, your invoice was submitted.', true);
                    },
                    e => that.onGqlError('Failed to submit invoice to xero.', e)
                );
            },
            e => that.onGqlError('Failed to update invoice.', e)
        );
    };

    onGqlError(userMessage, errorMessage) {
        console.error(userMessage, errorMessage);
        this.props.setSnackbarMessage(userMessage, false, null, errorMessage);
        this.setState({ loading: false });
    }
}

const convertQuotedAsLineItems = (quotes, isPurchase) => {
    return (
        (quotes &&
            quotes
                .filter(e => !!e.Accepted)
                .map(quote => {
                    const quoteItems = Object.assign([], quote.QuoteItems.edges || quote.QuoteItems);
                    return {
                        quoteID: quote.ID,
                        quoteType: quote.QuoteType,
                        items: quoteItems
                            .map(z => (z.node ? z.node : z))
                            .filter(e => !!e.Product && !!e.Product.ID && e.Product.ID > 0)
                            .map(e => {
                                // for invoices, use the price that was quoted.
                                // for bills, ignore the quoted price and use the original product worth.
                                const Price = isPurchase ? e.Product.BaseWorth : e.Price;
                                const HasGST = isPurchase ? e.Product.ITC : e.Product.GST;
                                return {
                                    ID: null,
                                    Quantity: e.Qty,
                                    Price,
                                    HasGST,
                                    Prepaid: isPurchase ? e.Prepaid || false : false,
                                    QuoteID: quote.ID,
                                    Product: { ...e.Product },
                                    Variation: { ...e.Variation }
                                };
                            })
                    };
                })) ||
        []
    );
};

const getPurchaseOrderList = form => {
    const supplierList = PO_SUPPLIER_LIST.map(supplier => {
        return { supplier: supplier, data: form.getField(supplier.key) || [] };
    }).filter(x => x.data.length > 0);

    //get Bills from suppliers
    const supplierPurchaseOrders = [];
    for (let x = 0; x < supplierList.length; x++) {
        for (let y = 0; y < supplierList[x].data.length; y++) {
            const supplier = supplierList[x].data[y];
            if (
                !isNullOrUndefined(supplier.PurchaseOrder) &&
                Number(supplier.PurchaseOrder.ID) > 0 &&
                Number(supplier.PurchaseOrder.Invoice.ID) > 0
            ) {
                supplierPurchaseOrders.push({
                    Supplier: supplierList[x].supplier.label,
                    PO: supplier.PurchaseOrder,
                    Confirmed: !!supplier.Confirmed ? 'Yes' : 'No'
                });
            }
        }
    }
    const disposalPurchaseOrders = PO_DOCTOR_LIST.map(field => {
        return { Supplier: field.label, PO: form.getField(field.key), Confirmed: 'Yes' };
    }).filter(po => !isNullOrUndefined(po.PO) && !isNullOrUndefined(po.PO.Invoice) && Number(po.PO.Invoice.ID) > 0);

    return disposalPurchaseOrders.concat(supplierPurchaseOrders);
};

const convertBookedAsLineItems = (form, isPurchase) => {
    if (!form) return;

    const assembleItem = bookingItem => {
        // first try to clean up the product data
        const theSources = assembleProduct(bookingItem);

        // the booking price already has GST applied, need to pull it out.
        const hasGST = isPurchase
            ? !isNullOrUndefined(theSources.Product.ITC)
                ? theSources.Product.ITC
                : true // don't know? assume it applies.
            : !isNullOrUndefined(theSources.Product.GST)
            ? theSources.Product.GST
            : true; // don't know? assume it applies.
        // if this is for an invoice, use the booking price minus any GST.
        // if this is for a bill, ignore the booking price and use the product's worth.
        const Price = isPurchase
            ? theSources.Variation.ID > 0
                ? theSources.Variation.Worth
                : theSources.Product.BaseWorth
            : hasGST
            ? bookingItem.UnitPrice / (GST + 1)
            : bookingItem.UnitPrice;
        return {
            orderID: true,
            Quantity: bookingItem.Quantity,
            Price, // no GST!
            HasGST: hasGST,
            ...theSources
        };
    };

    //get bookings from suppliers, but not coffin stuff.
    const bookingsList = PO_SUPPLIER_LIST.filter(obj => 'CommittalBookings' !== obj.key)
        .map(supplier => form.getField(supplier.key) || [])
        .filter(x => x.length > 0);
    const ordersList = [];
    for (let x = 0; x < bookingsList.length; x++) {
        for (let y = 0; y < bookingsList[x].length; y++) {
            const supplier = bookingsList[x][y];
            if (supplier.Confirmed) {
                if (supplier.BookingItems) {
                    ordersList.push(...supplier.BookingItems.map(bookingItem => assembleItem(bookingItem)));
                }
            }
        }
    }
    //get more Orders from the coffins and coffin accessories
    let disposalItems = form.getField('Disposal.DisposalBookingItems') || [];
    let coffins = disposalItems.filter(bookingItem => isCategory(bookingItem, QueryKeys.Coffins));
    let otherDisposalItems = disposalItems.filter(bookingItem => !isCategory(bookingItem, QueryKeys.Coffins));
    //get the first OR actual coffin
    let coffin = coffins.length === 1 ? coffins[0] : coffins.find(x => x.Quantity === 1);

    const disposalLineItems = (!isNullOrUndefined(coffin) ? [coffin] : [])
        .concat(otherDisposalItems)
        .map(bookingItem => assembleItem(bookingItem));

    //convert all into line items
    return [].concat(ordersList, disposalLineItems).filter(e => !!e.Product && !!e.Product.ID && e.Product.ID !== '0');
};

const convertBilledAsLineItems = (form, isPurchase) => {
    if (!form) return;
    const poList = form.getField('PurchaseOrders');

    const supplierList = PO_SUPPLIER_LIST.map(supplier => form.getField(supplier.key) || []).filter(x => x.length > 0);

    //get purchase orders from suppliers
    const supplierPurchaseOrders = [];
    for (let x = 0; x < supplierList.length; x++) {
        for (let y = 0; y < supplierList[x].length; y++) {
            const supplier = supplierList[x][y];
            if (
                supplier.Confirmed &&
                !isNullOrUndefined(supplier.PurchaseOrder) &&
                Number(supplier.PurchaseOrder.ID) > 0
            ) {
                supplierPurchaseOrders.push(supplier.PurchaseOrder);
            }
        }
    }

    //get purchase orders from doctors
    const doctorsPurchaseOrders = PO_DOCTOR_LIST.map(field => form.getField(field.key)).filter(
        po => !isNullOrUndefined(po) && Number(po.ID) > 0
    );

    const purchaseOrderIDs = doctorsPurchaseOrders.concat(supplierPurchaseOrders).map(e => e.ID);

    //convert all into line items
    const lineItems =
        (poList &&
            poList
                .filter(e => purchaseOrderIDs.find(f => e.ID === f))
                .map(purchaseOrder => {
                    return (
                        !!purchaseOrder.Products &&
                        purchaseOrder.Products.filter(obj => obj.Product).map(lineItem => {
                            const Variation = !!lineItem.Variation
                                ? {
                                      ID: lineItem.Variation.ID,
                                      InternalItemID: lineItem.Variation.InternalItemID,
                                      ShortDescription: lineItem.Variation.ShortDescription,
                                      GST: lineItem.Variation.GST,
                                      ITC: lineItem.Variation.ITC
                                  }
                                : null;
                            const isDisbursement = lineItem.Product.DisbursementItem || false;
                            const HasGST = isPurchase ? lineItem.Product.ITC : lineItem.Product.GST;
                            return {
                                Quantity: lineItem.Qty,
                                Price:
                                    isPurchase || isDisbursement
                                        ? lineItem.UnitPrice / (HasGST ? GST + 1 : 1) // what we're paying, not always same as Worth
                                        : Variation
                                        ? Variation.Price
                                        : lineItem.Product.BasePrice,
                                HasGST,
                                Product: {
                                    ID: lineItem.Product.ID,
                                    InternalItemID: lineItem.Product.InternalItemID,
                                    Title: lineItem.Product.Title,
                                    GST: lineItem.Product.GST,
                                    ITC: lineItem.Product.ITC
                                },
                                Variation,
                                billID: true
                            };
                        })
                    );
                })
                .flat()
                .filter(e => !!e)) ||
        [];
    return lineItems.filter(e => !!e.Product && !!e.Product.ID && e.Product.ID !== '0');
};

const assembleProduct = bookingItem => {
    const Product = {};
    const Variation = {};
    const ProductID = bookingItem.ProductID || null;
    const VariationID = bookingItem.VariationID || null;
    if (!bookingItem.Product && !!ProductID) {
        const theProduct = ProductConfig.productMap[ProductID];
        if (!!theProduct) {
            Product.ID = theProduct.id;
            Product.InternalItemID = theProduct.internalId;
            Product.Title = theProduct.title;
            if (!!theProduct.original) {
                Product.GST = theProduct.original.gst;
                Product.ITC = theProduct.original.itc;
                Product.BaseWorth = theProduct.original.worth;
                Variation.ID = '0';
            } else if (!!VariationID) {
                const theVariant = theProduct.variationMap[VariationID];
                if (!!theVariant) {
                    Variation.ID = theVariant.id;
                    Variation.InternalItemID = theVariant.internalId;
                    Variation.ShortDescription = theVariant.title.replace(theProduct.title + ' |', '');
                    Variation.GST = theVariant.gst;
                    Variation.ITC = theVariant.itc;
                    Variation.Worth = theVariant.worth;
                }
            }
        }
    } else if (!!bookingItem.Product && !!bookingItem.Product.ID) {
        Product.ID = bookingItem.Product.ID;
        Product.InternalItemID = bookingItem.Product.InternalItemID;
        Product.Title = bookingItem.Product.Title || 'N/A';
        Product.GST = bookingItem.Product.GST || true;
        Product.ITC = bookingItem.Product.ITC || true;
        Product.BaseWorth = bookingItem.Product.BaseWorth;

        if (!!bookingItem.Variation && bookingItem.Variation.ID) {
            Variation.ID = bookingItem.Variation.ID;
            Variation.InternalItemID = bookingItem.Variation.InternalItemID;
            Variation.ShortDescription = bookingItem.Variation.ShortDescription || 'N/A';
            Variation.GST = bookingItem.Variation.GST || true;
            Variation.ITC = bookingItem.Variation.ITC || true;
            Variation.Worth = bookingItem.Variation.Worth;
        } else {
            Variation.ID = '0';
        }
    }

    return { Product, Variation };
};

const styles = ({ breakpoints }) => ({
    modalMagick: {
        maxWidth: 1440,
        width: '100%',
        [breakpoints.down('sm')]: {
            margin: 6
        },
        '& > div:nth-child(2)': {
            padding: 8,
            position: 'relative',
            '& > div:first-child': {
                // Content area
                overflow: 'auto',
                maxHeight: 'calc(100vh - 20rem)',
                maxWidth: 1440,
                flexDirection: 'unset',
                margin: 0,
                marginTop: 36,
                paddingTop: 0
            },
            '& > div:nth-child(2)': {
                // Footer
                padding: '20px 22px',
                margin: 0,
                justifyContent: 'unset',
                [breakpoints.down('sm')]: {
                    padding: '12px 6px'
                },
                '& button': {
                    '& svg': { margin: 0 },
                    [breakpoints.down('sm')]: {
                        minWidth: 'unset',
                        width: '3.5rem',
                        '& svg': { fontSize: 32, margin: 0 },
                        '& > span > span': {
                            display: 'none'
                        }
                    }
                }
            }
        }
    }
});

// prettier-ignore
export default compose(
    withSnackbarMessage,
    withStyles(styles)
)(InvoiceModal);
